import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import { tannerGray, tannerSemantic, tannerWhite } from '../colors';

type MuiAutocomplete = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiAutocomplete'];
  defaultProps?: ComponentsProps['MuiAutocomplete'];
  variants?: ComponentsVariants['MuiAutocomplete'];
};

export const MuiAutocomplete: MuiAutocomplete = {
  styleOverrides: {
    inputRoot: {
      '& .prism-search': {
        minWidth: 100,
      },
    },
    listbox: {
      padding: 8,
      '& .MuiAutocomplete-option': {
        '&.Mui-focusVisible': {
          boxShadow: `0 0 0 2px ${tannerSemantic.info.color}`,
          outline: `3px solid ${tannerWhite}`,
          outlineOffset: 2,
          backgroundColor: tannerGray['100'],
        },
      },
    },
    endAdornment: {
      top: '50%',
      transform: 'translateY(-50%)',
    },
    tag: {
      margin: '2px 5px 2px 2px',
    },
  },
};
